/**
 * Routers do not scroll; browsers do the remembering. Without this, opening a machine from the fleet wall lands
 * you wherever the wall was left, which on a 30-row page is usually the middle of it.
 *
 * Only the path resets. In-page anchors (`/how-it-works#ai`) and the landing page's own jump links have to keep
 * their target, and `scroll-behavior: smooth` is deliberately overridden for this one scroll — an animated trip
 * to the top on every navigation feels like the page is late, and the CSS rule exists for reading links, not for
 * routing.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop(): null {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    const root = document.documentElement;
    const previous = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    root.style.scrollBehavior = previous;
  }, [pathname, hash]);
  return null;
}
